import Index from '@/pages/SingleProduct/Index';
import ProductInfo from '@/pages/SingleProduct/ProductInfo';
import ProductSaleInfo from '@/pages/SingleProduct/ProductSaleInfo';
import ProductProperty from '@/pages/SingleProduct/ProductProperty';
import ProductImage from '@/pages/SingleProduct/ProductImage';
import ProductComplete from '@/pages/SingleProduct/ProductComplete';

export default {
  path: 'single-product',
  redirect: 'single-product/product-info',
  name: 'SingleProduct',
  component: Index,
  children: [{
    path: 'product-info',
    name: 'ProductInfo',
    component: ProductInfo,
  }, {
    path: 'product-sale-info',
    name: 'ProductSaleInfo',
    component: ProductSaleInfo,
  }, {
    path: 'product-property',
    name: 'ProductProperty',
    component: ProductProperty,
  }, {
    path: 'product-image',
    name: 'ProductImage',
    component: ProductImage,
  }, {
    path: 'product-complete',
    name: 'ProductComplete',
    component: ProductComplete,
  }],
};
